import { FC } from 'react';

import { Tooltip } from 'ui/tooltip';
import { BrandAffinityLevel, useBrandAffinityTranslation } from 'modules/domains/brandAffinity';
import { AffinityScore } from 'modules/ai/XAI/audienceUserProfile';

import { BrandAffinityIcon } from './BrandAffinityIcon';
import { getScoreUIDataByLevel } from '../utils';
import { BodyDisabled, DateTimeUnderlineText } from '../Styles';
import {
  ScoreAndDateContainer,
  ScoreDataContainer,
  ScoreHeader,
  ScoreBody,
  TimestampText,
} from './ScoreCard.styles';

interface HistoryTooltipText {
  date: string;
}
const HistoryTooltipText: FC<React.PropsWithChildren<HistoryTooltipText>> = ({
  date,
  children,
}) => (
  <Tooltip tooltipContent={date}>
    <DateTimeUnderlineText>{children}</DateTimeUnderlineText>
  </Tooltip>
);

export interface AffinityScoreDataProps extends AffinityScore {
  isCurrentScore?: boolean;
  isError?: boolean;
}
export const AffinityScoreData: FC<React.PropsWithChildren<AffinityScoreDataProps>> = ({
  date = '',
  isCurrentScore = false,
  isError = false,
  label = BrandAffinityLevel.UNSCORED,
  relativeDate = '',
}) => {
  const { t } = useBrandAffinityTranslation();
  const { brandText } = getScoreUIDataByLevel(label);

  const ScoreComponent = isCurrentScore ? ScoreHeader : ScoreBody;
  const DateComponent = isCurrentScore ? TimestampText : HistoryTooltipText;
  const scoreContent = isError ? (
    <BodyDisabled data-test="brand-affinity-xai-score-data-error">No data available</BodyDisabled>
  ) : (
    <>
      <ScoreComponent data-test="affinity-score-brand-text" data-current-score={isCurrentScore}>
        {t(brandText)}
      </ScoreComponent>
      <DateComponent date={date}>{relativeDate}</DateComponent>
    </>
  );
  return (
    <ScoreDataContainer data-test="brand-affinity-xai-score-data">
      <BrandAffinityIcon
        isCurrentScore={isCurrentScore}
        label={isError ? BrandAffinityLevel.UNSCORED : label}
      />
      <ScoreAndDateContainer>{scoreContent}</ScoreAndDateContainer>
    </ScoreDataContainer>
  );
};
